/* ============================
 * 生年月日セレクト
 * 会員登録・会員情報変更の両方で使う。
 * ・選んだ年月に実在する日だけを「日」に出す（2月31日のような日付を選べなくする）
 * ・1つでも選ばれていたら3つとも required にする
 *
 * 生年月日そのものは任意項目。3つとも空なら required は付かず、送信を止めない。
 * ただし年だけ選んだような中途半端な状態は保存できないので、
 * 入力を始めたら3つ揃えるまでブラウザ標準の検証で止める。
 * ============================ */

$(function () {
	$('.js-birthday').each(function () {
		var $wrapper = $(this);
		var $year = $wrapper.find('.js-birthdayYear');
		var $month = $wrapper.find('.js-birthdayMonth');
		var $day = $wrapper.find('.js-birthdayDay');
		if (!$year.length || !$month.length || !$day.length) return;

		var dayPlaceholder = $day.find('option[value=""]').first().text();
		var currentLimit = null;

		$wrapper.on('change', 'select', function () {
			syncDayOptions();
			syncRequired();
		});

		syncDayOptions();
		syncRequired();

		function syncDayOptions() {
			var limit = daysInMonth($year.val(), $month.val());
			if (limit === currentLimit) return;
			currentLimit = limit;

			var selected = $day.val();
			var options = ['<option value="">' + dayPlaceholder + '</option>'];
			for (var day = 1; day <= limit; day++) {
				options.push('<option value="' + day + '">' + day + '</option>');
			}
			$day.html(options.join(''));

			// 31日を選んだあとに2月へ変えた場合など、その月に無い日は選択を外す
			$day.val(Number(selected) <= limit ? selected : '');
		}

		function syncRequired() {
			var anySelected = Boolean($year.val() || $month.val() || $day.val());
			$year.prop('required', anySelected);
			$month.prop('required', anySelected);
			$day.prop('required', anySelected);
		}
	});

	function daysInMonth(year, month) {
		var monthNumber = parseInt(month, 10);
		if (!monthNumber) return 31;

		// 年が未選択のうちはうるう年とみなして29日まで出す。
		// 年を選んだ時点で平年なら29日は消え、選択も外れる。
		var yearNumber = parseInt(year, 10) || 2000;
		return new Date(yearNumber, monthNumber, 0).getDate();
	}
});
